export default __webpack_public_path__ + "static/media/ina.5ff94478.png";